webpackJsonp([0],{

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(389),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(392),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f0d4d96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e9818c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d36ff366",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a4b4468",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(387),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0aa23023",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(388),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63111cae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'callback',
    data: function data() {
        return {
            title: 'Login callback'
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch('auth/LOGIN').then(function (redirect) {
            _this.$log.info('Callback redirect to ' + redirect);
            _this.$router.replace({ path: redirect });
        }).catch(function (error) {
            return _this.$store.commit('errors/ADD', error, { root: true });
        });
    }
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'callback',
    props: {
        provider: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            title: 'Login callback'
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch('profile/SAVE_CONNECTION', { ProviderId: this.provider, Query: this.$route.query }).then(function () {
            return _this.$router.replace({ path: '/me' });
        }).catch(function (error) {
            return _this.$store.commit('errors/ADD', error, { root: true });
        });
    }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Consent',
    data: function data() {
        return {
            modal: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('consents', ['issuer', 'intent', 'consent', 'redirect'])),
    methods: {
        back: function back() {
            this.$router.go(-1);
        },
        updateExpiration: function updateExpiration(value) {
            this.$store.commit('consents/UPDATE_EXPIRATION', value);
            this.modal = false;
        },
        revoke: function revoke() {
            this.$store.dispatch('consents/REVOKE').then(this.$router.go(-1));
        },
        update: function update() {
            this.$store.dispatch('consents/ACCEPT').then(this.$router.go(-1));
        }
    },
    created: function created() {
        this.$store.dispatch('consents/LOAD_CONSENT');
    }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ConsentRequest',
    data: function data() {
        return {
            modal: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('auth', ['profile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('consents', ['issuer', 'intent', 'consent', 'redirect', 'isAcceptable']), {
        picture: function picture() {
            if (this.profile) {
                return this.profile.picture;
            }

            return undefined;
        }
    }),
    methods: {
        back: function back() {
            this.$router.go(-1);
        },
        signOut: function signOut() {
            this.$store.commit('auth/LOGOUT');
            this.$router.push({ path: '/login' });
        },
        accept: function accept() {
            var _this = this;

            this.$store.dispatch('consents/ACCEPT').then(function () {
                window.location.href = _this.redirect;
            });
        },
        updateExpiration: function updateExpiration(value) {
            this.$store.commit('consents/UPDATE_EXPIRATION', value);
            this.modal = false;
        }
    },
    created: function created() {
        this.$store.dispatch('consents/LOAD_CONSENT');
    }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_time__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Consents',
    data: function data() {
        return {
            tabs: ['all', 'granted', 'revoked'],
            active_tab: 'all'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('consents', {
        consents: function consents(state) {
            return state.consents;
        }
    }), {
        filter: {
            get: function get() {
                return this.$store.state.consents.filter;
            },
            set: function set(filter) {
                this.$store.dispatch('consents/LOAD_MY_CONSENTS_FILTER', filter);
            }
        }
    }),
    methods: {
        key: function key(consent) {
            return consent.IntentIssuerCode + '_' + consent.IntentCode + '_' + consent.DataOwnerCode;
        },
        details: function details(item) {
            this.$router.push({ path: '/consents/' + item.IntentIssuerCode + '/' + item.IntentCode });
        },
        format: function format(time) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_time__["a" /* default */])(time);
        }
    },
    created: function created() {
        this.$store.dispatch('consents/LOAD_MY_CONSENTS');
    }
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'discover',
    data: function data() {
        return {};
    },

    computed: {},
    methods: {},
    created: function created() {}
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            title: 'Login'
        };
    },
    created: function created() {
        if (this.$store.state.route.query.autoLogin) {
            this.$store.commit('auth/AUTHORIZE', this.$store.state.route.query.redirect);
        }
    },

    methods: {
        signIn: function signIn() {
            this.$store.commit('auth/AUTHORIZE', this.$store.state.route.query.redirect);
        }
    }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'me',
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('auth', ['profile']), {
        size: function size() {
            return window.innerWidth + 'px';
        },
        picture: function picture() {
            if (this.profile) {
                return this.profile.picture;
            }

            return undefined;
        }
    }),
    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        },
        goProfile: function goProfile() {
            this.$router.push({ path: '/me/profile' });
        },
        signOut: function signOut() {
            this.$store.commit('auth/LOGOUT');
            this.$router.push({ path: '/login' });
        }
    },
    created: function created() {}
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'NotFound',
    data: function data() {
        return {
            title: 'Not Found',
            error: 404,
            msg: 'Not Found'
        };
    },
    created: function created() {
        this.$store.commit('nav/BREADCRUMBS', []);
    }
});

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'settings',
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vault',
    data: function data() {
        return {};
    },

    computed: {},
    methods: {},
    created: function created() {}
});

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".error-details[data-v-0aa23023]{top:0;bottom:0;left:0;right:0;position:absolute;text-align:center;padding-top:20%}.desc[data-v-0aa23023],h1[data-v-0aa23023]{display:inline-block;vertical-align:middle}h1[data-v-0aa23023]{border-right:1px solid rgba(0,0,0,.3);font-weight:700}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-me/src/pages/NotFound.vue"],"names":[],"mappings":"AACA,gCACE,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,kBAAmB,AACnB,kBAAmB,AACnB,eAAiB,CAClB,AACD,2CAEE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,oBACE,sCAAwC,AACxC,eAAiB,CAClB","file":"NotFound.vue","sourcesContent":["\n.error-details[data-v-0aa23023] {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: absolute;\n  text-align: center;\n  padding-top: 20%;\n}\nh1[data-v-0aa23023],\n.desc[data-v-0aa23023] {\n  display: inline-block;\n  vertical-align: middle;\n}\nh1[data-v-0aa23023] {\n  border-right: 1px solid rgba(0,0,0,0.3);\n  font-weight: 700;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".card__media[data-v-3e9818c9]{background-color:#37345a}.card__media__background[data-v-3e9818c9]{-webkit-filter:opacity(20%);filter:opacity(20%)}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-me/src/pages/ConsentRequest.vue"],"names":[],"mappings":"AACA,8BACE,wBAA0B,CAC3B,AACD,0CACE,4BAA6B,AAC7B,mBAAqB,CACtB","file":"ConsentRequest.vue","sourcesContent":["\n.card__media[data-v-3e9818c9] {\n  background-color: #37345a;\n}\n.card__media__background[data-v-3e9818c9] {\n  -webkit-filter: opacity(20%);\n  filter: opacity(20%);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Consent.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".card__media[data-v-5a4b4468]{background-color:#37345a}.card[data-v-5a4b4468] .card__media__background{-webkit-filter:opacity(20%);filter:opacity(20%)}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-me/src/pages/Me.vue"],"names":[],"mappings":"AACA,8BACE,wBAA0B,CAC3B,AACD,gDACE,4BAA6B,AAC7B,mBAAqB,CACtB","file":"Me.vue","sourcesContent":["\n.card__media[data-v-5a4b4468] {\n  background-color: #37345a;\n}\n.card[data-v-5a4b4468] .card__media__background {\n  -webkit-filter: opacity(20%);\n  filter: opacity(20%);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".backpane{background-color:#fff}.logo{font-size:64px;font-weight:600;text-align:center}.logo>.now{color:#e50146}.logo>.now,.logo>.yu{font-family:Quicksand}.logo>.yu{color:#37345a}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-me/src/pages/Login.vue"],"names":[],"mappings":"AACA,UACI,qBAAwB,CAE3B,AACD,MACI,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,WAEI,aAAe,CAClB,AACD,qBAHI,qBAAuB,CAM1B,AAHD,UAEI,aAAe,CAClB","file":"Login.vue","sourcesContent":["\n.backpane {\n    background-color: white;\n    /*background-color: #37345a;*/\n}\n.logo {\n    font-size: 64px;\n    font-weight: 600;\n    text-align: center;\n}\n.logo > .now {\n    font-family: Quicksand;\n    color: #e50146;\n}\n.logo > .yu {\n    font-family: Quicksand;\n    color: #37345a;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Vault.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".list__tile .visible-hover[data-v-d36ff366]{visibility:hidden}.list :hover .visible-hover[data-v-d36ff366]{visibility:visible}.granted[data-v-d36ff366]{color:#4caf50}.expired[data-v-d36ff366]{color:#ffc107}.revoked[data-v-d36ff366]{color:#ff5252}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-me/src/pages/Consents.vue"],"names":[],"mappings":"AACA,4CACE,iBAAmB,CACpB,AACD,6CACE,kBAAoB,CACrB,AACD,0BACE,aAAe,CAChB,AACD,0BACE,aAAe,CAChB,AACD,0BACE,aAAe,CAChB","file":"Consents.vue","sourcesContent":["\n.list__tile .visible-hover[data-v-d36ff366] {\n  visibility: hidden;\n}\n.list :hover .visible-hover[data-v-d36ff366] {\n  visibility: visible;\n}\n.granted[data-v-d36ff366] {\n  color: #4caf50;\n}\n.expired[data-v-d36ff366] {\n  color: #ffc107;\n}\n.revoked[data-v-d36ff366] {\n  color: #ff5252;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("cfcb8aae", content, true);

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("027de351", content, true);

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("24977daf", content, true);

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("1a73d3c8", content, true);

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("017a0260", content, true);

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("146f9bae", content, true);

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(379);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("2c7f228b", content, true);

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-details ma-0"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "display-1 pr-3 mr-3"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h2', {
    staticClass: "body-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('span', [_vm._v(".")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Settings")])
},staticRenderFns: []}

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Authorization callback for " + _vm._s(_vm.provider) + " ...")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "layout": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h1', [_vm._v("Discover")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "consent-request",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.picture,
      "height": "300px"
    }
  }, [_c('v-layout', {
    staticClass: "media",
    attrs: {
      "column": ""
    }
  }, [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Sign out")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-card-title', {
    staticClass: "white--text pl-5 pt-5"
  }, [_c('div', {
    staticClass: "display-1 pl-5 pt-5"
  }, [_vm._v(_vm._s(_vm.profile.name))])])], 1)], 1), _vm._v(" "), (_vm.intent) ? _c('v-card-text', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.intent.ShortDescription))]), _vm._v(" "), _c('div', {
    staticClass: "subheading pt-3"
  }, [_vm._v(_vm._s(_vm.intent.Description))]), _vm._v(" "), (_vm.intent) ? _c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.intent.Scopes), function(Scope) {
    return _c('v-list-tile', {
      key: Scope
    }, [_c('v-list-tile-content', [_c('v-list-tile-sub-title', {
      staticClass: "title subheading"
    }, [_vm._v(_vm._s(Scope))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    staticClass: "pt-2",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Expiration date",
      "prepend-icon": "event",
      "readonly": "",
      "value": _vm.consent.Expiration
    },
    on: {
      "input": _vm.updateExpiration
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "value": _vm.consent.Expiration
    },
    on: {
      "input": _vm.updateExpiration
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3 pr-3",
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "justify title caption"
  }, [_vm._v("\n                            " + _vm._s(_vm.issuer.Name) + " and NowYu will use this information in accordance with their respective terms of service and privacy policies.\n                        ")])])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "disabled": !_vm.isAcceptable
    },
    on: {
      "click": function($event) {
        _vm.accept()
      }
    }
  }, [_vm._v("Grant")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "consent",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [(_vm.intent) ? _c('v-card-text', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.intent.ShortDescription))]), _vm._v(" "), _c('div', {
    staticClass: "subheading pt-3"
  }, [_vm._v(_vm._s(_vm.intent.Description))]), _vm._v(" "), (_vm.intent) ? _c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.intent.Scopes), function(Scope) {
    return _c('v-list-tile', {
      key: Scope
    }, [_c('v-list-tile-content', [_c('v-list-tile-sub-title', {
      staticClass: "title subheading"
    }, [_vm._v(_vm._s(Scope))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    staticClass: "pt-2",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Expiration date",
      "prepend-icon": "event",
      "readonly": "",
      "value": _vm.consent.Expiration
    },
    on: {
      "input": _vm.updateExpiration
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "value": _vm.consent.Expiration
    },
    on: {
      "input": _vm.updateExpiration
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3 pr-3",
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "justify title caption"
  }, [_vm._v("\n                            " + _vm._s(_vm.issuer.Name) + " and NowYu will use this information in accordance with their respective terms of service and privacy policies.\n                        ")])])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("\n                    Back\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.revoke()
      }
    }
  }, [_vm._v("\n                    Revoke\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v("\n                    Update\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.picture,
      "height": "300px"
    }
  }, [_c('v-layout', {
    staticClass: "media",
    attrs: {
      "column": ""
    }
  }, [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.goProfile()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Sign out")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-card-title', {
    staticClass: "white--text pl-5 pt-5"
  }, [_c('div', {
    staticClass: "display-1 pl-5 pt-5"
  }, [_vm._v(_vm._s(_vm.profile.name))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('me-profile-connections'), _vm._v(" "), _c('me-datastore-connections')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v("now")]), _c('span', {
    staticClass: "yu"
  }, [_vm._v("yu")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "mt6": "",
      "primary": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.signIn()
      }
    }
  }, [_vm._v("Login")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "layout": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h1', [_vm._v("Vault")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Login callback ...")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [(_vm.consents && _vm.consents.length > 0) ? _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-5"
  }, [_c('v-tabs-slider', {
    staticClass: "accent"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab,
      attrs: {
        "ripple": "",
        "href": '#' + tab
      }
    }, [_vm._v("\n                            " + _vm._s(tab) + "\n                        ")])
  })], 2)], 1), _vm._v(" "), _vm._l((_vm.consents), function(item, index) {
    return _c('v-list-tile', {
      key: _vm.key(item),
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: item.Status
    }, [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Intent.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.format(item.Expiration)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "visible-hover"
    }, [_vm._v("mode_edit")])], 1)], 1)
  })], 2)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.d8ba3b853bf5dc27fff0.js